import React, { useRef, useState } from "react";
import OfficersForm from "./OfficersForm";
import { useCallbackPrompt } from "../../hooks/useCallbackPrommpt";
import ConfirmationDialog from "../confirmation-dialog/ConfirmationDialog";
import PropTypes from "prop-types";
import { useNavigate, useParams } from "react-router-dom";
// import { useParams } from "react-router-dom";

const AddOfficers = ({ type }) => {
  const { current: initialOfficerData } = useRef({
    id: "",
    name: "",
    other_name: "",
    last_name: "",
    preferred_name: "",
    role: { name: "", code: "" },
    title: "",
    email: "",
    country: { name: "", code: "" },
    phone_code: "",
    phone: "",
    entity: "",
    expiration_date: "",
    acting_as: "",
  });
  const { id: entityid } = useParams();
  const [showDialog, setShowDialog] = useState(false);
  const navigate = useNavigate();
  const [showPrompt, confirmNavigation, cancelNavigation] =
    useCallbackPrompt(showDialog);
  const [regData, setRegData] = useState(initialOfficerData);

  const resetRegData = (data = {}) => {
    setRegData({
      ...initialOfficerData,
      ...data,
    });
  };

  const handleConfirmNavigation = () => {
    resetRegData();
    navigate(
      type === "officer"
        ? `/entity/${entityid}/appointments-ownership?tab=officers`
        : `/entity/${entityid}/appointments-ownership?tab=power-of-attorney`,
      {
        state: { skipBlocker: true },
      },
    );
  };

  return (
    <>
      <ConfirmationDialog
        show={showPrompt}
        onConfirm={handleConfirmNavigation}
        onCancel={cancelNavigation}
      />
      <OfficersForm
        setShowDialog={setShowDialog}
        type={type}
        regData={regData}
        setRegData={setRegData}
        resetRegData={resetRegData}
      />
    </>
  );
};

AddOfficers.propTypes = {
  type: PropTypes.string.isRequired,
};

export default AddOfficers;
